.wrap {
  min-height: 50vh;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 14px;
  animation: appear 0.3s ease-out 0.3s both;
}

.mark {
  display: block;
  overflow: visible;
}

.letter {
  fill: var(--text);
}

.moon {
  fill: var(--accent);
  animation: breathe 2.4s ease-in-out infinite;
}

.spark {
  fill: var(--accent-soft);
  animation: twinkle 1.6s ease-in-out infinite;
}

.large {
  transform-origin: 80px 27px;
}

.small {
  transform-origin: 86px 40px;
  animation-delay: 0.8s;
}

.badge {
  fill: var(--accent);
}

.caption {
  margin: 0;
  font-size: 13px;
  color: var(--muted);
}

@keyframes appear {
  from {
    opacity: 0;
  }
}

@keyframes breathe {
  0%,
  100% {
    opacity: 0.65;
  }
  50% {
    opacity: 1;
  }
}

@keyframes twinkle {
  0%,
  100% {
    transform: scale(0.3);
    opacity: 0.15;
  }
  40% {
    transform: scale(1.15);
    opacity: 1;
  }
  60% {
    transform: scale(1);
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .moon,
  .spark {
    animation: none;
  }

  .mark {
    animation: breathe 2.4s ease-in-out infinite;
  }
}
